import Column from '../../core/components/box/column';
import SizedBox from '../../core/components/box/sizedBox';
import LXInput from '../../core/texts/lxInput';
import { LXbody, LXh2 } from '../../core/texts/lxText';
import { ReactComponent as KlabLogo } from '../../../assets/logos/klabLogo.svg';
import Row from '../../core/components/box/row';
import { useTheme } from 'styled-components';
import LXLargeButton from '../../core/components/buttons/lxLargeButton';
import useSignInPageController from '../../../1_application/auth/signInPageController';
import { useEffect } from 'react';

const SignInForm: React.FC = () => {
  const theme = useTheme();
  const s = useSignInPageController();

  useEffect(() => {
    const handleEnter = (event: KeyboardEvent) => {
      if (event.key === 'Enter' && s.buttonRef.current)
        s.buttonRef.current.click();
    };
    window.addEventListener('keydown', handleEnter);
    return () => window.removeEventListener('keydown', handleEnter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Column>
      <KlabLogo width={107} height={40}></KlabLogo>
      <SizedBox height={20}></SizedBox>
      <LXh2>{theme.texts.signIn}</LXh2>
      <SizedBox height={40}></SizedBox>
      <LXbody>{theme.texts.id}</LXbody>
      <SizedBox height={8}></SizedBox>
      <LXInput
        type="email"
        onChange={s.handleEmailInput}
        width={320}
        placeholder={theme.texts.enterClinicId}
        tabIndex={1}
      ></LXInput>
      <SizedBox height={16}></SizedBox>
      <Row justifyContent="space-between">
        <LXbody>{theme.texts.password}</LXbody>
        <LXbody onClick={s.redirectToForgetPage} color={theme.colors.caption}>
          {theme.texts.forgotPassword}
        </LXbody>
      </Row>
      <SizedBox height={8}></SizedBox>
      <LXInput
        type="password"
        onChange={s.handlePasswordInput}
        width={320}
        placeholder={theme.texts.enterPassword}
        tabIndex={2}
      ></LXInput>
      <SizedBox height={40}></SizedBox>
      <LXLargeButton refProp={s.buttonRef} onClick={s.onSignIn()} tabIndex={3}>
        {theme.texts.signIn}
      </LXLargeButton>
    </Column>
  );
};

export default SignInForm;
